import axios from "axios";
import {
	UPDATE_STATUS_USER,
	FETCH_USERS,
	UPDATE_PASS,
	CREATE_USER,
	UPDATE_USER,
	BILL_INFO,
} from "constants/ActionTypes";

const AUTH_TOKEN =
	"eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJoZWFkZXIiOnsiaWQiOiIwIiwidXNlciI6Ik1hbnVlbEdpbCJ9LCJwYXlsb2FkIjp7ImlhdCI6IjIwMTktMDEtMDEgMDA6MDA6MDAiLCJleHAiOiIyMDIwLTAxLTAxIDAwOjAwOjAwIn19.p_PtmXsDe3l_osPEzb4edkf-M2SCdUVBQBKs8ZAbpn8";
const ROOT_URL2 =
	"https://admingreenerapp.crsostenible.com/api/public/api/app/";

export function fetchUsers() {
	const ROUTINES = "user/get";
	const request = axios({
		method: "get",
		url: `${ROOT_URL2}${ROUTINES}`,
		headers: {
			"Content-Type": "application/json",
			Authorization: "Bearer " + AUTH_TOKEN,
		},
	})
		.then((request) => request.data.data)
		.catch((error) => error);
	return {
		type: FETCH_USERS,
		payload: request,
	};
}

export function createUser(
	{ cedula, nombre, telefono, email, passReal, accountType },
	callback
) {
	const ROUTINES = `register`;
	const request = axios({
		method: "post",
		url: `${ROOT_URL2}${ROUTINES}`,
		data: {
			identification: cedula,
			full_name: nombre,
			phone: telefono,
			email: email,
			password: passReal,
			account_type: accountType,
		},
		headers: {
			"Content-Type": "application/json",
			Authorization: "Bearer " + AUTH_TOKEN,
		},
	})
		.then((request) => request.success)
		.then(callback());
	return {
		type: CREATE_USER,
		payload: request,
	};
}

export function updateUser(
	{ id, identification, name, phone, email, accountType },
	callback
) {
	const ROUTINES = "profile/edit";
	const request = axios({
		method: "post",
		url: `${ROOT_URL2}${ROUTINES}`,
		data: {
			user_id: id,
			identification: identification,
			full_name: name,
			phone: phone,
			email: email,
			account_type: accountType,
		},
		headers: {
			"Content-Type": "application/json",
			Authorization: "Bearer " + AUTH_TOKEN,
		},
	})
		.then((request) => request.success)
		.then(callback());
	return {
		type: UPDATE_USER,
		payload: request,
	};
}

export function updateStatusUser(
	user_id,
	user_status,
	callback = () => console.log()
) {
	const ROUTINES = "user/update_status";
	const request = axios({
		method: "post",
		url: `${ROOT_URL2}${ROUTINES}`,
		data: {
			user_id: user_id,
			status: user_status,
		},
		headers: {
			"Content-Type": "application/json",
			Authorization: "Bearer " + AUTH_TOKEN,
		},
	})
		.then((request) => request.success)
		.then(callback());
	return {
		type: UPDATE_STATUS_USER,
		payload: request,
	};
}

export function updatePass(
	{ email, passReal },
	callback = () => console.log()
) {
	const ROUTINES = "security/update_passwords";
	const request = axios({
		method: "post",
		url: `${ROOT_URL2}${ROUTINES}`,
		data: {
			email: email,
			password: passReal,
		},
		headers: {
			"Content-Type": "application/json",
			Authorization: "Bearer " + AUTH_TOKEN,
		},
	}).then((request) => request.status);
	return {
		type: UPDATE_PASS,
		payload: request,
	};
}



// WEBPACK FOOTER //
// ./src/appRedux/actions/Users.js